import { DateFormat } from "../../../../../../constants";
import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form44 = (record: any) => {
  return {
    departmentCode: "3",
    aflType: AFLType.AFLSuspendContract,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: "CHI NHÁNH ĐÀ NẴNG",
        },
      },
      {
        type: "title",
        value: {},
      },
      {
        type: "salutation",
        value: ["Giám đốc Chi nhánh"],
      },
      {
        type: "content",
        value: [
          { type: "eRequestNameAndId", value: { name: record?.eRequestName, id: record?.eEmployeeId } },
          {
            type: "ePositionAndTeam",
            value: {
              position: StringHelper.verticalBarSplit<string[]>(record?.eTitle)[1],
              team: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
            },
          },
          {
            type: "eDoBAndSabre",
            value: {
              dob: record?.eEmployeeBirthday?.format(DateFormat.DD_MM_YYY) || "",
              sabre: record?.eCodeSabre || "",
            },
          },
          {
            type: "eAddress",
            value: record?.eAddress || "",
          },
          {
            type: "eBusinessTime",
            value: record?.eBusinessTime || "",
          },
          {
            type: "eLongReason",
            value: {
              reason: record?.eReason || "",
              place: record?.eLeavePlace || "",
              range: record?.eVacationPeriods[0],
              title: "tạm hoãn hợp đồng lao động",
              directorTitle: "Giám đốc Chi nhánh"
            },
          },
          {
            type: "",
            value: `Tôi xin cam đoan chấp hành Quy định, thực hiện các thủ tục có liên quan và chịu trách nhiệm hoàn toàn tính xác thực trước pháp luật. `,
          },
          { type: "", value: "Tôi xin trân trọng cảm ơn !" },
        ],
      },
      {
        type: "dateSection",
        value: "",
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["Ý KIẾN BỘ PHẬN", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
        textBreak: 1,
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["PHÊ DUYỆT CỦA GIÁM ĐỐC", record?.eSteps[3][0].name],
          },
          {
            type: "signature1",
            value: ["Ý KIẾN KHHC", record?.eSteps[2][0].name],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
